import { getGuid } from 'owa-guid';
import { lazySetCollabSpaceViewStateId } from 'owa-calendar-compose-form-store';
import { initializeStore } from '../mutators/initializeStore';

export function createCollabSpaceViewStateId(): string {
    const viewStateId = getGuid();
    lazySetCollabSpaceViewStateId.importAndExecute(viewStateId);
    initializeStore(viewStateId);

    return viewStateId;
}
